export const GET_SOCIETIES = 'sagas/society/GET_SOCIETIES';
export const GET_SOCIETY = 'sagas/society/GET_SOCIETY';
export const CREATE_SOCIETY = 'sagas/society/CREATE_SOCIETY';
